import { render } from "./ag-policy-select.vue?vue&type=template&id=66f7afa4"
import script from "./ag-policy-select.vue?vue&type=script&lang=js"
export * from "./ag-policy-select.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__